// Index file for the directory. Don't add anything else here.
import CarouselYogatimeTransaction from './CarouselYogatimeTransaction';
export default CarouselYogatimeTransaction;
